<kui-modal size="md" class="details-modal" [title]="title() | translate" [actions]="modalActions">
    <div class="p-4">
        <key-save-video-confirmation [displayButtons]="false" />
    </div>
</kui-modal>
